import { ConfigKeys, getConfig } from '@/common/config'
import { computed } from 'vue'

export interface BuildInfo {
  number: string
  sha: string
  date: string
  version: string
}

export function useBuildInfo() {
  const buildNumber = computed(() => getConfig(ConfigKeys.BUILD_NUMBER))
  const buildSha = computed(() => getConfig(ConfigKeys.BUILD_SHA))
  const buildDate = computed(() => getConfig(ConfigKeys.BUILD_DATE))
  const appVersion = computed(() => getConfig(ConfigKeys.APP_VERSION))

  const buildVersion = computed(() => {
    const version = appVersion.value
    const num = buildNumber.value
    const sha = buildSha.value
    if (num === 'dev') {
      return `v${version} (Development)`
    }
    return `v${version} - Build #${num} (${sha})`
  })

  const buildInfo = computed<BuildInfo>(() => ({
    number: buildNumber.value,
    sha: buildSha.value,
    date: buildDate.value,
    version: buildVersion.value,
  }))

  const isProductionBuild = computed(() => buildNumber.value !== 'dev')

  const formattedBuildDate = computed(() => {
    if (buildSha.value === 'local') {
      return 'Local build'
    }
    try {
      return new Date(buildDate.value).toLocaleString()
    } catch {
      return buildDate.value
    }
  })

  return {
    buildNumber,
    buildSha,
    buildDate,
    buildVersion,
    buildInfo,
    isProductionBuild,
    formattedBuildDate,
    appVersion,
  }
}
